import { render } from "./KanbanToolbar.vue?vue&type=template&id=0dbfdd01&scoped=true"
import script from "./KanbanToolbar.vue?vue&type=script&lang=js"
export * from "./KanbanToolbar.vue?vue&type=script&lang=js"

import "./KanbanToolbar.vue?vue&type=style&index=0&id=0dbfdd01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dbfdd01"]])

export default __exports__